export default __webpack_public_path__ + "static/media/c001-Picture3.e3881828.jpg";